import React, { FC } from 'react'
import styles from './TableBody.module.scss'

type TableBodyProps = React.TableHTMLAttributes<HTMLTableSectionElement>

export const TableBody: FC<TableBodyProps> = ({ children, ...props }) => {
  return (
    <tbody {...props} className={styles.tableBody}>
      {children}
    </tbody>
  )
}

TableBody.displayName = 'TableBody'
